import Headroom from 'headroom.js';

function init() {

	const headroom = new Headroom(document.querySelector('.top-bar'), {
		offset: 300,
		tolerance: 5
	});
	headroom.init();

}

export default {
	init
};
